import React, { useState, createContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toTitleCase } from '../util/titleCase';
import ReactGA from 'react-ga';

const DataContext = createContext();
const { Provider } = DataContext;

const DataProvider = ({ children }) => {
  const TRACKING_ID = "UA-23405765-9"; // TRACKING_ID
  ReactGA.initialize(
    TRACKING_ID
  );
    const history = useHistory()
    const [homework, setHomework] = useState(null);
    const [showMenu, setShowMenu] = useState(false);
    const [chatroom, setClickedChatroom] = useState(null);
    const [groupChat, setGroupChat] = useState(true);
    const [clickedGroupId, setClickedGroupId] = useState('');
    const [groupName, setGroupName] = useState('');
    const [teachers, setTeachers] = useState(false);
    const [hideSidebar, setHideSidebar] = useState(true);
    const [chats, setChats] = useState([]);
    const [ clickedVideoUrl, setClickedVideoUrl] = useState('');
    const [initialVideo, setInitialVideo] = useState('');
    const [videoExtract, setVideoExtract] = useState([]);
    const [cbtData, setCbtData] = useState([]);
    const [clickedCbtItem, setClickedCbtItem] = useState(null);
    const [examQuestions, setExamQuestions] = useState([]);
    const [ defaultSchoolData, setDefaultSchoolData] = useState({});
    const [messageFromBackEnd, setMessageFromBackEnd] = useState({});
    const [chatGroupLoading, setChatGroupLoading] = useState(false);
    const [chatGroupFetchError, setChatGroupFetchError] = useState('');

    const defaultSchoolDataLS = JSON.parse(localStorage.getItem('schoolInfo'))
    
    useEffect(() => {
      ReactGA.pageview(window.location.pathname + window.location.search);
      document.title = (`Edves Students Portal - ${defaultSchoolDataLS && toTitleCase(defaultSchoolDataLS.defaultSchoolName)}`);
      return () => {
      }
    })

    const setMenu = verdict => {
      setShowMenu(verdict)
    };

    const setSubject = (subject) => {
        setHomework(subject)
    };

    const setChatroom = (clicked) => {
      setClickedChatroom(clicked)
      console.log(window.innerWidth)
      window.innerWidth <= 640 && history.push('clickedMenu')
    };

    const setToggleGroup = () => {
      setGroupChat(!groupChat);
      setTeachers(!teachers)
    };

    return (
        <Provider
          value={{
            homework,
            setHomework : (subject) => setSubject(subject),
            setShowMenu: verdict => setMenu(verdict),
            showMenu,
            setClickedChatroom: clicked => setChatroom(clicked),
            chatroom,
            toggleGroup: () => setToggleGroup(),
            groupChat,
            setClickedGroupId,
            clickedGroupId,
            setGroupName,
            groupName,
            teachers,
            setSideBarHidden: hide => setHideSidebar(hide),
            hideSidebar,
            chats,
            setChats,
            setClickedVideoUrl,
            clickedVideoUrl,
            setInitialVideo,
            initialVideo,
            setVideoExtract,
            videoExtract,
            setCbtData,
            cbtData,
            setClickedCbtItem,
            clickedCbtItem,
            setExamQuestions,
            examQuestions,
            setDefaultSchoolData,
            defaultSchoolData,
            setMessageFromBackEnd,
            messageFromBackEnd,
            setChatGroupLoading,
            chatGroupLoading,
            setChatGroupFetchError,
            chatGroupFetchError
          }}
        >
          {children}
        </Provider>
    );

}

export { DataContext, DataProvider };